export interface WhatsAppEngine {
  id: string;
  type: 'whatsapp';
  name: string;
  domain: string;
  connectionTime: string;
}

export interface DisplayEngine {
  id: string;
  type: 'gateway' | 'whatsapp-web' | 'whatsapp';
  name: string;
  status: string;
  domain: string;
  connectionTime: string;
  canDelete: boolean;
  canRestart: boolean;
  qrCode?: string;
  session?: any; // For gateway engines that have session data
  isLegacy?: boolean; // For old gateway engines that need upgrade warning
}

export const ENGINE_STATUS_COLORS = {
  'connected': 'var(--status-success)',
  // An engine without a (current) contractVersion: online, but it needs an update (plan A.9.5).
  'update_required': 'var(--status-warning)',
  'qrcode': 'var(--status-warning)', 
  'initializing': 'var(--status-info)',
  'browser_started': 'var(--status-info)',
  'navigating': 'var(--status-info)',
  'waiting_for_whatsapp_page': 'var(--status-info)',
  'unpaired': 'var(--status-warning)',
  'awaiting_phone': 'var(--status-warning)',
  'pairing_code': 'var(--status-warning)',
  'syncing': 'var(--status-info)',
  'disconnected': 'var(--status-error)',
  'error': 'var(--status-error)',
} as const;
